const EventsArray2020 = [
    {
        link: "https://iittp.ac.in/distinguished-lectures",
        title: "Lecture on 'Invitation to Inverse Problems'",
        dt: "14",
        my: "Oct"
    },
    {
        link: "#msc",
        title: "Launching Masters in Chemistry @ IIT Tirupati",
        dt: "31",
        my: "Aug"
    },
    {
        link: "https://iittp.ac.in/special-talks",
        title: 'Talk on "COVID 19"',
        dt: "17",
        my: "Mar"
    }
];

export default EventsArray2020;
